<template>
  <!-- <div style="display: block;"> -->
    <!-- v-show="dragGeneralState.active" -->
    <div
      id="drag-preview"
      class="drag-el"
      :style="{
        left: dragGeneralState.x + 'px',
        top: dragGeneralState.y + 'px',
      }"
    >
      <app-icon
        class="drag-el__icon"
        :name="dragIconName"
        width="18px"
        color="#979797"
        cursor="pointer"
      />
      <div class="drag-el__text">
        {{ dragGeneralState.name }}
      </div>
      <div class="drag-el__count">
        {{ dragGeneralState.count }}
      </div>
    </div>
    <div
      v-if="dragGeneralState.count > 1"
      class="drag-el"
      :style="{
        zIndex: 99,
        left: dragGeneralState.x + 4 + 'px',
        top: dragGeneralState.y + 4 + 'px',
      }"
    >
      <app-icon
        class="drag-el__icon"
        :name="dragIconName"
        width="18px"
        color="#979797"
        cursor="pointer"
      />
      <div class="drag-el__text">
        {{ dragGeneralState.name }}
      </div>
    </div>
  <!-- </div> -->
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { DragGeneralState } from "@/models/interfaces/file/file-model";
import AppIcon from "../ui-kit/icon/AppIcon.vue";
import { typeIconMap } from "@/utils/fileIcons";

const dragGeneralState = inject<DragGeneralState>("dragGeneralState", {
  name: "",
  type: "",
  count: 0,
  active: false,
  x: 0,
  y: 0,
});



const dragIconName = computed(() => {
  return typeIconMap[dragGeneralState.type] || "file-universal";
});
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.drag-el {
//   transform: translate(100px, 100px);
  box-sizing: border-box;

  display: flex;
  //   flex-direction: column;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;

  position: fixed;

  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 12px;

  //   max-width: 350px;
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;

  pointer-events: none;
  z-index: 100;

  &__text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #4d4d4d;
  }

  &-lot-count {
    z-index: 9998;
  }

  &__icon {
    display: inline;
  }

  .drag-el__count {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);

    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 22px;
    height: 22px;
    padding: 0 6px;

    border-radius: 9999px;
    background-color: $color-on-accent;
    color: $background-white;

    z-index: 200;
  }
}
</style>
